import { CustomValidators } from 'shared/validation/custom-validators';
import { AbstractControl, ValidatorFn, UntypedFormControl } from '@angular/forms';
import * as _ from 'lodash';

import { getEmailListFromStr } from 'utils/utils';


export const emailListValidation = (required: boolean = false) => {
  return {
    'EMAIL_LIST_VALIDATION': {
      'custom': function (): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} => {
          const emailInvalidErr = {'EMAILS': 'One of emails is invalid'};
          const emailList = getEmailListFromStr(control.value);

          if (required && !emailList.length) {
            return {'EMAILS': 'Emails must be provided'};
          }

          const errItem = _.find(emailList, (value: string) => {
            if (!value) { return false; }
            const testControl = new UntypedFormControl(value);
            return (!_.isNil(CustomValidators.email(testControl)));
          });

          if (errItem) { return emailInvalidErr; }
          return null;
        };
      },
    },
  };
};
